import { useContext } from 'react'
import { RunStateContext } from '../provider/runStateContext.internal'

export function useRunState() {
    const runState = useContext(RunStateContext)

    if (!runState) {
        throw new Error('useRunState must be used inside RunStateProvider')
    }

    return runState
}